import {
  GET_LEDGER_DETAILS_REQUEST,
  GET_LEDGER_DETAILS_SUCCESS,
  GET_LEDGER_DETAILS_FAILURE,
} from '../constants/ActionTypes';
import {
  GetLedgerDetailsRequestAction,
  GetLedgerDetailsSuccessAction,
  ILedgerFilterPayload,
  ILedgerDetails,
  GetLedgerDetailsFailureAction,
} from '../types/ledgerDetails.types';
export const getLedgerDetailsRequest = (
  ledgerFilterPayload: ILedgerFilterPayload
): GetLedgerDetailsRequestAction => ({
  type: GET_LEDGER_DETAILS_REQUEST,
  payload: ledgerFilterPayload,
});

export const getLedgerDetailsSuccess = (
  ledgerDetails: ILedgerDetails
): GetLedgerDetailsSuccessAction => ({
  type: GET_LEDGER_DETAILS_SUCCESS,
  payload: { ledgerDetails },
});

export const getLedgerDetailsFailure = (
  error: string
): GetLedgerDetailsFailureAction => ({
  type: GET_LEDGER_DETAILS_FAILURE,
  payload: { error },
});

export type BackofficeActions =
  | GetLedgerDetailsRequestAction
  | GetLedgerDetailsSuccessAction
  | GetLedgerDetailsFailureAction;
